import API from "../api";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    listModality: [],
    listSubModality: [],
    currentModality: {
      id: null,
      nome: null,
      ativo: null
    }
  },
  mutations: {
    setListModality(state, payload) {
      state.listModality = payload;
    },
    setListSubModality(state, payload) {
      state.listSubModality = payload;
    },
    setCurrentModality(state, payload) {
      state.currentModality = payload;
    },
    addItemListModality(state, payload) {
      state.listModality.unshift(payload);
    },
    addItemListSubModality(state, payload) {
      state.listSubModality.unshift(payload);
    },
    changeItemListSubModality(state, payload) {
      const item = state.listSubModality.find(x => x.id == payload.id);
      const position = state.listSubModality.indexOf(item);
      let list = _.cloneDeep(state.listSubModality);
      list[position] = payload;
      state.listSubModality = list;
    }
  },
  actions: {
    async requestModality({ commit }) {
      const { data } = await API.getModality();
      commit("setListModality", data.items);
    },
    async requestSubModality({ commit }, payload) {
      const { data } = await API.getSubModality(payload);
      commit("setListSubModality", data.items);
    },
    async requestSubModalitiesOfModality({ commit }, modalityId) {
      const { data } = await API.getSubModalitiesOfModality(modalityId);
      commit("setListSubModality", data.items);
    },
    async requestCurrentModality({ commit }, payload) {
      const { data } = await API.getCurrentModality(payload);
      commit("setCurrentModality", data);
    },
    async requestPostModality({ commit }, payload) {
      const { data } = await API.postModality(payload);
      commit("addItemListModality", data);
    },
    async requestPutModality({ commit }, payload) {
      const { data } = await API.putModality(payload);
      commit("setCurrentModality", data);
    },
    async requestPostSubModality({ commit }, payload) {
      const { data } = await API.postSubModality(payload);
      commit("addItemListSubModality", data);
    },
    async requestPutSubModality({ commit }, payload) {
      const { data } = await API.putSubModality(payload);
      commit("changeItemListSubModality", data);
    },
    async requestUploadIcon(context, payload) {
      const { data } = await API.uploadIcon(payload);
      return data;
    }
  },
  modules: {}
};
